//Jquery Start
;(function ($) {
  // Mobile toogle menu
  if (!$(".mobile_nav").hasClass("mobile-slide-nav")) {
    $(".mobilelistnav a.has-children").on("click", function () {
      if ($(this).attr("href") == "#") {
        $(this).parent().toggleClass("openlist")
        $(this).parent().next(".sub-menu-wrp").stop().slideToggle()

        $(this).next(".sub_menu_btn").toggleClass("close_sub_menu")

        return false
      }
    })
    $(".sub_menu_btn").on("click", function () {
      $(this).toggleClass("close_sub_menu")
      $(this).parent().next(".sub-menu-wrp").stop().slideToggle()
      $(this).parent().toggleClass("openlist")
    })
  } else {
    $(".mobilelistnav a.has-children").on("click", function () {
      if ($(this).attr("href") == "#") {
        $(this).parent().toggleClass("openlist")
        $(this).next(".sub_menu_btn").toggleClass("close_sub_menu")

        return false
      }
    })
    $(".sub_menu_btn").on("click", function () {
      $(this).toggleClass("close_sub_menu")
      $(this).parent().toggleClass("openlist")
    })
    $(".sub-menu-header").on("click", function () {
      $(this).parent().prev(".parent-link-wrapper").removeClass("openlist")
      $(this).parent().prev(".parent-link-wrapper").children(".sub_menu_btn ").removeClass("close_sub_menu")
    })
  }
  //Target Window Open
  $(".open_target").on("click", function () {
    $($(this).data("target")).fadeIn().addClass("show")
    $(this).addClass("show")
    return false
  })
  $(".close_target").on("click", function () {
    $($(this).data("target")).removeClass("show").fadeOut()
    $(".open_target, .mobilebtn").removeClass("show")
    $("body").removeClass("scroll-hidden")
    return false
  })
  $(".mobilebtn").on("click", function () {
    if ($(this).hasClass("show")) {
      $($(this).data("target")).removeClass("show").fadeOut()
      $(this).removeClass("show")
      if ($(window).scrollTop() === 0 && !$("body").hasClass("product") && !$("body").hasClass("page--faq") && !$("body").hasClass("blog") && !$("body").hasClass("collection") && !$("body").hasClass("page") && !$("body").hasClass("article")) {
        $("header").addClass("transparent_header")
      }
      $("body").removeClass("scroll-hidden")
    } else {
      $($(this).data("target")).fadeIn().addClass("show")
      $(this).addClass("show")
      $("header").removeClass("transparent_header")
      $("body").addClass("scroll-hidden")
    }
    return false
  })
  //Hover drop down menu
  function firstLevelDropDownHoverHandler() {
    if ($(this).hasClass("megamenu-children") === false && $(this).hasClass("children") === false && $(this).hasClass("open") === false) {
      $(".menu-list__item").removeClass("open")
    } else {
      $(".menu-list__item").removeClass("open")
      $(this).addClass("open")
    }
  }
  function firstLevelDropDownKeydownHandler() {
    if ($(this).hasClass("open") === true) {
      $(".menu-list__item").removeClass("open")
    } else {
      $(".menu-list__item").removeClass("open")
      $(this).addClass("open")
    }
  }
  function secondLevelDropDownHoverHandler() {
    if ($(this).hasClass("megamenu-children") === false && $(this).hasClass("children") === false && $(this).hasClass("open") === false) {
      $(".menu-list__item-2").removeClass("open")
    } else {
      $(".menu-list__item-2").removeClass("open")
      $(this).addClass("open")
    }
  }
  function secondLevelDropDownKeydownHandler() {
    if ($(this).hasClass("open") === true) {
      $(".menu-list__item").removeClass("open")
    } else {
      $(".menu-list__item").removeClass("open")
      $(this).addClass("open")
    }
  }
  //first level drow down
  $(".menu-list__item").hover(firstLevelDropDownHoverHandler)
  $(".menu-list__item").on("keydown", function (event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault()
      firstLevelDropDownKeydownHandler.call(this)
    }
  })
  //second level drow down
  $(".menu-list__item-2").hover(secondLevelDropDownHoverHandler)
  $(".menu-list__item-2").on("keydown", function (event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault()
      secondLevelDropDownKeydownHandler.call(this)
    }
  })

  $("header.header").hover(
    function () {},
    function () {
      $(".menu-list__item, .menu-list__item-2").removeClass("open")
    }
  )
  if ($("header.header").hasClass("transparent_header")) {
    $("header.header").hover(
      function () {
        $(this).addClass("header-hover")
      },
      function () {
        $(this).removeClass("header-hover")
      }
    )
  }

  //Header search toogle window
  $(".search-btn").on("click", function () {
    if ($(this).hasClass("search-toggle-open")) {
      $(".header__search").addClass("show")
      $("body").addClass("overflow-hidden")
    } else {
      $("details-modal.header__search").removeClass("show")
      $("body").removeClass("overflow-hidden")
    }
  })
  //focus on
  $(".head-search-btns").on("click", function () {
    setTimeout(function () {
      $(".search-full .search__input").focus()
    }, 300)
  })
  //Footer menu columns mobile toogle
  if ($(window).width() < 769) {
    $(".footer-menu-label").on("click", function () {
      $(".footer-menu-label").not(this).removeClass("toogle-menu").next().stop().slideUp()

      if (!$(this).hasClass("toogle-menu")) {
        $(this).addClass("toogle-menu")
        $(this).next().stop().slideDown()
      } else {
        $(this).next().stop().slideUp()
        $(this).removeClass("toogle-menu")
      }
    })
  }
})(jQuery) //END jQuery
